import { useNavigate } from "react-router-dom";
import { FileText, ArrowRight } from "lucide-react";
import quotationsData from "../data/quotationsData";

function money(n) {
    return `₹${n.toLocaleString("en-IN")}`;
}

export default function MyEnquiries() {
    const navigate = useNavigate();

    return (
        <div>
            <h1 className="text-3xl font-extrabold text-gray-900">My Enquiries</h1>
            <p className="text-gray-500 mt-1 mb-6">
                All open prototype enquiries you have published
            </p>

            <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-5">
                {quotationsData.map((q) => (
                    <div
                        key={q.id}
                        className="rounded-xl border bg-card text-card-foreground shadow p-5 hover:shadow-elevated transition"
                    >
                        {/* Top row: ID + status */}
                        <div className="flex items-center justify-between mb-4">
                            <span className="text-xs font-mono font-medium px-2.5 py-1 rounded-lg bg-gray-50 border border-gray-200 text-gray-600">
                                {q.id}
                            </span>
                            <span className="text-xs font-semibold px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 border border-indigo-100">
                                {q.status}
                            </span>
                        </div>

                        {/* Title + description */}
                        <h2 className="font-bold text-gray-900 text-lg mb-1">{q.title}</h2>
                        <p className="text-sm text-gray-500 mb-4">{q.description}</p>

                        {/* Spec chips */}
                        <div className="flex flex-wrap gap-1 mb-5">
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {q.category}
                            </span>
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {money(q.budgetMin)} – {money(q.budgetMax)}
                            </span>
                            <span className="text-xs font-medium px-2 py-1.5 rounded-lg bg-white border border-gray-200 text-gray-700">
                                {q.targetDate}
                            </span>
                        </div>

                        {/* Footer: quotations count + open button */}
                        <div className="flex items-center justify-between border-t border-gray-100 pt-4">
                            <span className="flex items-center gap-1.5 text-sm text-gray-600">
                                <FileText className="w-4 h-4 text-blue-500" />
                                {q.quotes.length} quotation{q.quotes.length === 1 ? "" : "s"}
                            </span>
                            <button
                                type="button"
                                onClick={() => navigate(`/app/quotations/${q.id}`)}
                                className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-8 rounded-md px-3 text-xs"
                            >
                                Open
                                <ArrowRight className="w-4 h-4" />
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {quotationsData.length === 0 && (
                <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
                    You haven't published any enquiries yet.
                </div>
            )}

        </div>
    );
}